import React, { useState, useEffect } from 'react';
import { CardComponentProps } from '@/lib/cards';
import { getCurrentUser, AuthUser } from '@/api/user';

/**
 * Profile Identity Card
 * Displays user identity information (read-only)
 */
export const IdentityCard: React.FC<CardComponentProps> = ({
  card,
  userContext,
  onError,
}) => {
  const [data, setData] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);
        const user = await getCurrentUser();
        setData(user);
      } catch (err) {
        onError?.(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [onError]);

  if (loading) {
    return <div style={{ padding: '1rem', color: '#666' }}>Loading identity information...</div>;
  }

  if (!data) {
    return <div style={{ padding: '1rem', color: '#666' }}>No identity data available</div>;
  }

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ marginBottom: '0.75rem' }}>
        <strong>Name:</strong> {data.displayName}
      </div>
      <div style={{ marginBottom: '0.75rem' }}>
        <strong>Email:</strong> {data.email}
      </div>
      <div style={{ marginBottom: '0.75rem' }}>
        <strong>User ID:</strong> {data.id}
      </div>
      <div>
        <strong>Tier:</strong> {data.tier}
      </div>
    </div>
  );
};

IdentityCard.displayName = 'IdentityCard';

export default IdentityCard;
